import React from 'react';
import { isBot } from '../utils/botDetection';

/**
 * EnvironmentGuard handles environmental constraints before the application mounts.
 *
 * 1. Bot Detection: Prevents crawlers from mounting the application to reduce noise and API load.
 * 2. No-JS: Handled by <noscript> in the public index.html.
 */
export const EnvironmentGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // If it's a known bot/crawler, we don't render anything.
  // This avoids unnecessary API calls and Sentry initialization errors.
  if (isBot()) {
    return null;
  }

  return children as React.ReactElement;
};
